import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spyc',
  templateUrl: './spyc.component.html',
  styleUrls: ['./spyc.component.scss']
})
export class SpycComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
